import { toast } from "react-toastify";
import { CalculateFinalPrice } from "../metadata/CalculatePrice";

export function GetIndividualBonusSoftware(services, masters, serviciosCatalogo) {
  try {
    if (!Array.isArray(services) || services.length === 0) return 0;

    let totalByRango = 0;
    let totalMontoVendido = 0;

    for (const service of services) {
      const finalPrice = CalculateFinalPrice(service, serviciosCatalogo);
      totalMontoVendido += finalPrice;

      const rangoRule = masters.find(
        (r) =>
          r.category === "Software" &&
          r.rangeMin <= finalPrice &&
          (r.rangeMax === null || r.rangeMax >= finalPrice)
      );

      const porcentaje = rangoRule?.percentage
        ? (rangoRule.percentage / 100) * finalPrice
        : 0;

      const fijo = Number(rangoRule?.fixedCommission) || 0;

      totalByRango += porcentaje + fijo;
    }

    // Buscar regla de meta
    const metaRule = masters.find(
      (r) =>
        r.category === "Software" &&
        r.metaMonthly &&
        totalMontoVendido >= r.metaMonthly
    );

    const bonoMeta = metaRule?.fixedCommission || 0;

    return totalByRango + bonoMeta;
  } catch (e) {
    return 0;
  }
}
